<template>
  <div class="home">
    <div class="home1">古戏台简介</div>
    <div class="header">
      <img src="@/assets/gxt.jpg" alt="">
    </div>
    <div class="tit">
      <div class="tit1">详情简介：</div>
      <div class="tit2" v-html='text'></div>

    </div>
    <button ref="clickMe" @click="speakText" style="display:none"></button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      textToSpeak:
        "戏曲文化传承与展示,古戏台位于井谷里文化公园东北侧，坐东朝西，重修于民国三年（1914 年）。古戏台为歇山式屋顶，前接歇山卷棚顶抱厦，曲线优美，坡度平缓，高 8.36 米（其中台基高 1.65 米），东西长 11.85 米，南北宽 11.35 米，建筑面积 134.5 平方米，面阔三间，精致典雅。前台两侧建有回音壁，与台面相交呈“八”字形，回音壁上有砖雕“福”字图案。中间立柱上对联内容为行书“人逢盛世笑口开，好戏连台聚仙来”。梁枋饰以淡雅的旋子彩画，前后台之间有木屏隔扇，屋顶全覆绿色琉璃瓦，正脊脊刹为二层楼阁式宝顶，两侧为仙人走兽，戏台前后台门额部彩绘图案有亭台楼阁、文人仕女、园林花木以及文房四宝，中门上绘有古松之下骑鹿的寿星，二童子相伴，一童子捧仙桃，一童子持杖背葫芦，象征年寿人丰。2009年成为太原市文物保护单位。古戏台作为文物保护单位，是小井峪村历史文化的重要见证。在设计中，遵循文物保护原则，对古戏台进行精心修复与保护，保留其原始的建筑结构和艺术特色，如精美的藻井、木雕戏文等。古戏台是太原戏曲文化传承的重要载体，定期在戏台上举办晋剧等地方戏曲表演，让游客近距离欣赏太原传统戏曲艺术的魅力。在戏台周边设置戏曲文化展示区，通过图片、文字、实物等形式介绍山西戏曲的历史渊源、发展脉络、表演形式以及著名戏曲艺人等。这不仅丰富了游客的文化体验，也有助于太原戏曲文化的传承与弘扬。文化聚集与乡村活力激发古戏台是井谷里文化公园内的文化核心区域，具有强大的文化聚集效应。戏曲表演吸引游客和当地村民聚集于此，形成一个充满活力的文化交流场所。这种文化聚集能够带动周边商业活动的发展，如小吃摊、手工艺品摊等的设立，为乡村振兴增添经济活力。同时，古戏台所营造的浓厚文化氛围也有助于提升小井峪村的文化软实力，吸引更多的文化资源和投资，促进乡村的全面振兴。",
      text: '<p><strong style="color: rgb(44, 44, 54);">戏曲文化传承与展示</strong></p><p>\t<span style="color: rgb(0, 0, 0);">古戏台位于井谷里文化公园东北侧，坐东朝西，重修于民国三年（1914 年）。古戏台为歇山式屋顶，前接歇山卷棚顶抱厦，曲线优美，坡度平缓，高 8.36 米（其中台基高 1.65 米），东西长 11.85 米，南北宽 11.35 米，建筑面积 134.5 平方米，面阔三间，精致典雅。前台两侧建有回音壁，与台面相交呈“八”字形，回音壁上有砖雕“福”字图案。中间立柱上对联内容为行书“人逢盛世笑口开，好戏连台聚仙来”。梁枋饰以淡雅的旋子彩画，前后台之间有木屏隔扇，屋顶全覆绿色琉璃瓦，正脊脊刹为二层楼阁式宝顶，两侧为仙人走兽，戏台前后台门额部彩绘图案有亭台楼阁、文人仕女、园林花木以及文房四宝，中门上绘有古松之下骑鹿的寿星，二童子相伴，一童子捧仙桃，一童子持杖背葫芦，象征年寿人丰。2009年成为太原市文物保护单位。古戏台作为文物保护单位，是小井峪村历史文化的重要见证。在设计中，遵循文物保护原则，对古戏台进行精心修复与保护，保留其原始的建筑结构和艺术特色，如精美的藻井、木雕戏文等。古戏台是太原戏曲文化传承的重要载体，定期在戏台上举办晋剧等地方戏曲表演，让游客近距离欣赏太原传统戏曲艺术的魅力。</span></p><p>\t<span style="color: rgb(0, 0, 0);">在戏台周边设置戏曲文化展示区，通过图片、文字、实物等形式介绍山西戏曲的历史渊源、发展脉络、表演形式以及著名戏曲艺人等。这不仅丰富了游客的文化体验，也有助于太原戏曲文化的传承与弘扬。</span></p><p><strong style="color: rgb(44, 44, 54);">文化聚集与乡村活力激发</strong></p><p>\t<span style="color: rgb(44, 44, 54);">古戏台是井谷里文化公园内的文化核心区域，具有强大的文化聚集效应。戏曲表演吸引游客和当地村民聚集于此，形成一个充满活力的文化交流场所。这种文化聚集能够带动周边商业活动的发展，如小吃摊、手工艺品摊等的设立，为乡村振兴增添经济活力。同时，古戏台所营造的浓厚文化氛围也有助于提升小井峪村的文化软实力，吸引更多的文化资源和投资，促进乡村的全面振兴。</span></p>',
    };
  },
  mounted() {
    this.$refs.clickMe.click();
    // 在组件创建时设置TTS监听路由变化
    this.unregisterHook = this.$router.afterEach((to, from) => {
      if (to !== from) {
        this.stopTTS();
      }
    });
  },
  methods: {
    // 播放
    speakText() {
      if ("speechSynthesis" in window) {
        const msg = new SpeechSynthesisUtterance(this.textToSpeak);
        // 设置语音合成的参数
        msg.lang = "zh-CN"; // 设置语言
        msg.rate = 1; // 设置语速
        msg.pitch = 1; // 设置音调
        msg.volume = 1; // 设置音量
        // 开始播放
        window.speechSynthesis.speak(msg);
        // 监听结束事件
        msg.onend = () => {};
      }
    },
    stopTTS() {
      window.speechSynthesis.cancel();
    },
  },
};
</script>


<style scoped>
.home1 {
  height: 50px;
  text-align: center;
  font-weight: 700;
  line-height: 3;
}

.header {
  width: 96%;
  height: 32vh;
  box-sizing: border-box;
  margin: 0 auto;
  border-radius: 50%;
}

.header > img {
  width: 100%;
  height: 100%; /* 高度自动调整 */
  border-radius: 8px;
}
.tit {
  width: 95%;
  margin: 20px auto;
}

.tit1 {
  font-weight: 700;
  letter-spacing: 3px;
}

.tit2 {
  margin-top: 4%;
  line-height: 2.5;
  letter-spacing: 3px;
  text-indent: 2em;
}

.tit3 {
  margin-top: 4%;
  line-height: 2.5;
  letter-spacing: 3px;
  font-weight: 700;
}

.tit4 {
  margin-top: 4%;
  line-height: 2.5;
  letter-spacing: 3px;
  text-indent: 2em;
}
</style>
